(function($) {
    'use strict';

    function validateInputs($form) {
        var $inputsToValidate = $form.find('[data-validate]');
        var isFormValid = true;

        $inputsToValidate.each(function(index, input) {
            isFormValid = $(input).validate() && isFormValid;
        });

        return isFormValid;
    }

    function validateRecaptcha($form) {
        var $grecapcha = $form.find('.g-recaptcha');
        if ($grecapcha.length) {
            var grecaptchaResponse = $grecapcha
                .find('textarea[name=g-recaptcha-response]')
                .val();

            if (grecaptchaResponse.length === 0) {
                var message = $grecapcha.data('required-message');
                $grecapcha
                    .next('.validation-error')
                    .find('span')
                    .text(message);
                $grecapcha.addClass('has-error');

                return false;
            } else {
                $grecapcha.removeClass('has-error');
            }
        }

        return true;
    }

    $.fn.validateForm = function() {
        var $form = this;
        var isValid = true;

        if (!validateInputs($form)) {
            $form.trigger('inputsInvalid');
            isValid = false;
        }

        if (!validateRecaptcha($form)) {
            $form.trigger('recaptchaInvalid');
            isValid = false;
        }

        return isValid;
    };

    $.fn.resetForm = function () {
        var $form = this;
        $form.trigger('reset');
        $form.find('.has-error, .success').removeClass('has-error success');
    }
})(jQuery);
